(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["helior-collection-toolbar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('helior-metal')) {
    customElements.define('helior-metal', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const listener = { signal: this.abort.signal };
        this.details = this.querySelector('details');
        this.trigger = this.querySelector('summary');
        this.links = Array.from(this.querySelectorAll('a'));
        this.refreshLinks();
        this.trigger.addEventListener('click', () => {
          this.refreshLinks();
          document.querySelectorAll('helior-sort').forEach(control => control.close?.());
        }, listener);
        this.details.addEventListener('toggle', () => this.trigger.setAttribute('aria-expanded', String(this.details.open)), listener);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.details.open) {
            event.preventDefault();
            event.stopPropagation();
            this.close();
            this.trigger.focus();
          }
          if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            this.refreshLinks();
            document.querySelectorAll('helior-sort').forEach(control => control.close?.());
            this.details.open = true;
            const index = this.links.indexOf(document.activeElement);
            let next = event.key === 'ArrowUp' ? (index - 1 + this.links.length) % this.links.length : (index + 1) % this.links.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.links.length - 1;
            this.links[next]?.focus();
          }
        }, listener);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, listener);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, listener);
      }
      refreshLinks() {
        this.links.forEach(link => {
          const url = new URL(link.href, window.location.origin);
          url.search = window.location.search;
          url.searchParams.delete('page');
          url.searchParams.delete('section_id');
          link.href = url.href;
        });
      }
      close() { this.details.open = false; }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["helior-launch-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const hideExpired = () => document.querySelectorAll('[data-helior-offer-end]').forEach(element => {
    if (Date.now() >= Date.parse(element.dataset.heliorOfferEnd)) element.hidden = true;
  });
  hideExpired();
  document.addEventListener('shopify:section:load', hideExpired);
  window.setInterval(hideExpired, 60000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["helior-sort"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('helior-sort')) {
    customElements.define('helior-sort', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.select = this.querySelector('select');
        this.trigger = this.querySelector('.helior-sort__trigger');
        this.list = this.querySelector('[role="listbox"]');
        if (!this.select || !this.trigger || !this.list) return;
        this.ready = true;
        this.abort = new AbortController();
        const listener = { signal: this.abort.signal };
        this.list.replaceChildren();
        Array.from(this.select.options).filter(option => !option.hidden).forEach(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'helior-sort__option';
          button.role = 'option';
          button.tabIndex = -1;
          button.dataset.value = option.value;
          button.setAttribute('aria-selected', String(option.selected));
          const label = document.createElement('span');
          label.textContent = option.textContent;
          button.append(label);
          button.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="m2 6 2.5 2.5L10 3" stroke="currentColor" stroke-width="1"/></svg>');
          this.list.append(button);
          button.addEventListener('click', () => this.choose(option.value), listener);
        });
        this.trigger.addEventListener('click', () => this.toggle(), listener);
        this.select.addEventListener('change', () => this.choose(this.select.value), listener);
        this.addEventListener('keydown', event => this.onKey(event), listener);
        this.addEventListener('keyup', event => { if (event.key === 'Escape') event.stopPropagation(); }, listener);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) this.close(); }, listener);
        document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) this.close(); }, listener);
        this.select.hidden = true;
        this.trigger.hidden = false;
      }
      disconnectedCallback() { this.abort?.abort(); this.ready = false; }
      options() { return Array.from(this.list.querySelectorAll('[role="option"]')); }
      toggle() {
        if (!this.list.hidden) { this.close(); return; }
        document.querySelectorAll('helior-metal').forEach(control => control.close?.());
        document.querySelectorAll('helior-sort').forEach(control => { if (control !== this) control.close?.(); });
        this.list.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        (this.options().find(option => option.getAttribute('aria-selected') === 'true') || this.options()[0])?.focus();
      }
      close(restore = false) {
        this.list.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (restore) this.trigger.focus();
      }
      choose(value) {
        this.select.value = value;
        const label = this.select.selectedOptions[0].textContent.trim();
        this.querySelector('.helior-sort__value').textContent = label;
        this.trigger.setAttribute('aria-label', `${this.dataset.sortLabel} ${label}`);
        this.options().forEach(option => option.setAttribute('aria-selected', String(option.dataset.value === value)));
        this.close(true);
        const form = this.closest('facet-filters-form');
        if (form && typeof form.onSubmitHandler === 'function') {
          this.select.dispatchEvent(new Event('input', { bubbles: true }));
        } else {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', value);
          url.searchParams.delete('page');
          const facets = customElements.get('facet-filters-form');
          if (typeof facets?.renderPage === 'function' && document.getElementById('product-grid')) {
            facets.renderPage(url.searchParams.toString());
          } else {
            window.location.assign(url);
          }
        }
      }
      onKey(event) {
        if (event.key === 'Escape' && !this.list.hidden) { event.preventDefault(); event.stopPropagation(); this.close(true); return; }
        if (event.key === 'Tab') { this.close(); return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (this.list.hidden) { this.toggle(); return; }
        const options = this.options();
        const index = options.indexOf(document.activeElement);
        let next = event.key === 'ArrowDown' ? (index + 1) % options.length : (index - 1 + options.length) % options.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = options.length - 1;
        options[next]?.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
